import React from 'react';
import {Navigate} from 'react-router-dom';
import {ROUTE_BASE_ROOT, ROUTE_WILDCARD} from './RoutePathConstant';

export const PublicRoute = [{
  path: ROUTE_WILDCARD,
  element: (<Navigate to={ROUTE_BASE_ROOT} />),
}];
